import moment from "moment";
import { Link } from "react-router-dom";
import { Space, Button, Table, Popconfirm, Tooltip } from "antd";
import { DeleteOutlined, PlusOutlined, SendOutlined } from "@ant-design/icons";

import { useGroupActivity } from "./useActivity";

export const ActivityWidget = () => {
  const {
    loading,
    data,
    setPage,
    deleteGroupActivity,
    limit,
    setLimit,
    sendGroupActivity,
  } = useGroupActivity();
  return (
    <>
      <div className="page-header">
        <h3>Мэдэгдэл жагсаалт</h3>
        <Space>
          <Link to={"/activity/add"}>
            <Button type="primary" icon={<PlusOutlined />}>
              Мэдэгдэл нэмэх
            </Button>
          </Link>
        </Space>
      </div>
      <div className="page-body">
        <div className="page-table">
          <Table
            scroll={{ x: 900 }}
            dataSource={data?.groupActivities ?? []}
            size="small"
            loading={loading}
            pagination={{
              pageSize: limit,
              total: Number(data?.totalPages) * limit,
              showSizeChanger: true,
              onChange: (page, pageSize) => {
                setPage(page - 1);
                setLimit(pageSize);
              },
            }}
            bordered
            columns={[
              {
                title: "Нэр",
                dataIndex: "name",
                key: "name",
                render: (text) => <span>{text}</span>,
              },
              {
                title: "Үүссэн огноо",
                dataIndex: "createdAt",
                key: "createdAt",
                render: (text) => (
                  <span>{moment(text).format("YYYY/MM/DD HH:mm:ss")}</span>
                ),
              },
              {
                title: "",
                dataIndex: "button",
                key: "button",
                fixed: "right",
                width: "90px",
                render: (_, record) => {
                  return (
                    <Space>
                      <Tooltip title="Мэдэгдэл илгээх">
                        <Button
                          type="primary"
                          shape="circle"
                          disabled={loading}
                          icon={<SendOutlined />}
                          onClick={() => {
                            if (record._id) {
                              sendGroupActivity(record._id);
                            }
                          }}
                        />
                      </Tooltip>
                      <Popconfirm
                        disabled={loading}
                        title="Та устгахдаа итгэлтэй байна уу?"
                        okText="Тийм"
                        cancelText="Үгүй"
                        onConfirm={() => {
                          if (record._id) {
                            deleteGroupActivity(record._id);
                          }
                        }}
                      >
                        <Button
                          size="middle"
                          shape="circle"
                          disabled={loading}
                          danger
                          type="primary"
                          icon={<DeleteOutlined />}
                        />
                      </Popconfirm>
                    </Space>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};
